export interface SseConfig {
  maxReconnectAttempts?: number;
  baseReconnectDelay?: number;
  maxReconnectDelay?: number;
  heartbeatInterval?: number;
}

export const DEFAULT_SSE_CONFIG: Required<SseConfig> = {
  maxReconnectAttempts: 10,
  baseReconnectDelay: 1000, // 1 second
  maxReconnectDelay: 60000, // 60 seconds
  heartbeatInterval: 30000, // 30 seconds
};
